// src/components/LanguageHandler.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function LanguageHandler() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const langParam = queryParams.get('lang');
    
    if (langParam && ['en', 'fr'].includes(langParam.toLowerCase())) {
      const currentLang = i18n.language;
      const newLang = langParam.toLowerCase();
      
      if (currentLang !== newLang) {
        i18n.changeLanguage(newLang);
      }
    }
  }, [location.search, i18n]);

  return null;
}

export default LanguageHandler;